<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import { usePagination } from "~/composables/paginations/usePagination";
import { useCategoriesStore } from "~/store/categories/categories.store";
import { useCreateTrainingStore } from "~/store/trainings/create-training.store";
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import { useTrainingPrefillStore } from "~/store/copilot/training-prefill.store";
import { hostsTrainingModal, queryWithoutTrainingId } from "~/utils/helpers/trainings/training-modal-host";

const createTrainingStore = useCreateTrainingStore();
const categoriesStore = useCategoriesStore();
const prefillStore = useTrainingPrefillStore();
const router = useRouter();
const paginate = usePagination();

async function exit() {
  createTrainingStore.showExit = false;
  createTrainingStore.isEdit = false;
  createTrainingStore.$reset();
  // Only what this form invented: the list is shared, and over another page a reset would empty
  // the very categories that page is showing.
  categoriesStore.dropUnsavedCategories();
  prefillStore.reset();

  // The query and the list behind the form belong to the pages that host it themselves; over
  // another page neither is ours to touch.
  if (!hostsTrainingModal(router.currentRoute.value)) return;

  await router.push({ query: queryWithoutTrainingId(router.currentRoute.value.query) });
  await paginate.fetchData();
}

function stay() {
  createTrainingStore.showExit = false;
  createTrainingStore.showModal = true;
}
</script>

<template>
  <CenterModal :style="{ 'max-width': '488px', width: '100%' }">
    <template #body>
      <div class="p-[24px]">
        <h4 class="heading_3_demi">Quitter sans sauvegarder</h4>
        <p class="body_regular text-secondary-color pt-[8px]">Vos modifications seront perdues.</p>
        <div class="flex justify-end gap-[16px] pt-[16px]">
          <AppButton type="outlined" label="Retour" @click="stay()" />
          <AppButton label="Quitter" @click="exit()" />
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped lang="scss"></style>
